import createCrudService from '@core/api/create-crud-service';

import { QUERY_KEYS } from '@shared/constants/query-keys';
import type { TBaseQuery } from '@shared/types/base-query';
import type { TUser } from '@shared/types/user';

type TUserQuery = TBaseQuery;

type TUserPayload = {
  first_name: string;
  last_name: string;
  email: string;
  phone_number: string;
  avatar: string | File;
  timezone: string;
  whatsapp_number: string;
  date_of_birth: string;
  language: TUser['language'];
  type: TUser['type'];
  english_level: TUser['english_level'];
  gender: TUser['gender'];
  role: number;
};

const userApi = createCrudService<TUser, TUserQuery, TUserPayload>({
  queryKey: [QUERY_KEYS.getUsers],
  url: 'users',
  validateQuery: [QUERY_KEYS.getStudents, QUERY_KEYS.getMembers],
});

export default userApi;
